import { studentsActionTypes } from '.';

export const init = (view: StaticView) => ({
  type: studentsActionTypes.INIT,
  payload: { view },
} as const);
export const getFiltersList = (view: StaticView) => ({
  type: studentsActionTypes.FILTERS_GET_CONFIG_START,
  payload: { view },
} as const);
export const refreshFilterValues = (view: StaticView) => ({
  type: studentsActionTypes.FILTERS_REFRESH_VALUES_START,
  payload: { view },
} as const);
export const getData = (view: StaticView) => ({
  type: studentsActionTypes.GET_DATA_START,
  payload: { view },
} as const);
export const getDataNextPage = (view: StaticView) => ({
  type: studentsActionTypes.GET_DATA_NEXT_PAGE_START,
  payload: { view },
} as const);
export const getColumnsConfig = (view: StaticView) => ({
  type: studentsActionTypes.COLUMNS_GET_CONFIG_START,
  payload: { view },
} as const);
export const saveColumnsUserSetup = (view: StaticView, selectedColumns: SelectedColumns) => ({
  type: studentsActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { view, selectedColumns },
} as const);
export const saveColumnsUserSetupSuccess = (view: StaticView) => ({
  type: studentsActionTypes.COLUMNS_SAVE_USER_SETUP_SUCCESS,
  payload: { view },
} as const);
export const getRecordDetails = (view: StaticView, id: string | number) => ({
  type: studentsActionTypes.RECORD_GET_DETAILS_START,
  payload: { view, id },
} as const);
export const refreshData = (view: StaticView) => ({
  type: studentsActionTypes.REFRESH_DATA_START,
  payload: { view },
} as const);
